import axios from 'axios'
import * as utils from './apiUtils'

export default {
  getMovices(params) {
    return axios.get(utils.getApiUrl('/land_ap/emergencies'), {
      params: params || {}
    })
  },
  getDevices() {
    return axios.get(utils.getApiUrl('/land_ap/devices'))
  },
}
